import { Box, Divider, IconButton } from '@mui/material';
import zeplinColor from 'theme/Color';
import { ReactComponent as EditIcon } from 'assets/edit.svg';
import DeleteIcon from 'assets/delete-red.png';
import { LightTooltip } from 'components/shared/CustomTooltip/CustomTooltip';
import { Typography } from '@mui/material';
import style from '../CustomViewLead.module.css';
import CustomButton from 'components/shared/CustomButton/CustomButton';

export const HeaderActions = ({
  onEdit,
  onDelete,
  onClose,
  onConvert,
}: {
  onEdit: () => void;
  onDelete: () => void;
  onClose: (event: React.KeyboardEvent | React.MouseEvent) => void;
  onConvert: () => void;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',

        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px',
      }}
    >
      <Typography variant='responsiveHeading2'>Lead Details</Typography>
      <Box
        sx={{
          display: 'flex',

          alignItems: 'center',
          gap: '12px',
        }}
      >
        <CustomButton
          disabled={false}
          variant='outlined'
          color='customSecondary'
          style={{
            color: zeplinColor.BasicBlack,
            width: 'fit-content',
            minWidth: 'max-content',
            flexShrink: 0,
            margin: 'auto',
            borderRadius: '14px',
            height: 40,
            borderWidth: 1,
            borderColor: zeplinColor.Neutral9,
            display: 'flex',
            gap: '8px',
            '&:hover': {
              backgroundColor: zeplinColor.Neutral5,
            },
          }}
          textStyle={{ whiteSpace: 'nowrap' }}
          text={'Convert to Client'}
          iconPosition='start'
          icon={<img src={'/assets/convert-client.svg'} />}
          onClick={onConvert}
          // tabindex={5}
        />
        <LightTooltip
          title={
            <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
              Edit
            </Typography>
          }
          placement='bottom'
        >
          <IconButton size='small' onClick={onEdit}>
            <EditIcon width={20} height={20} />
          </IconButton>
        </LightTooltip>
        <LightTooltip
          title={
            <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
              Delete
            </Typography>
          }
          placement='bottom'
        >
          <IconButton size='small' onClick={onDelete}>
            <img src={DeleteIcon} width={20} height={20} alt='delete' />
          </IconButton>
        </LightTooltip>
        <Divider
          orientation='vertical'
          flexItem
          sx={{
            borderColor: zeplinColor.Neutral5,
            height: '24px',
            margin: '0 4px',
            alignSelf: 'center',
          }}
        />
        <img
          src={'/assets/close-icon.svg'}
          className={style['icon']}
          alt='close'
          style={{ cursor: 'pointer' }}
          onClick={onClose}
        />
      </Box>
    </Box>
  );
};
